// leaveLiveStreams.js
'use strict';
import setActiveStreamId from '../action/setActiveStreamId.js';
import setPrivateStreamAutoPayment from '../action/setPrivateStreamAutoPayment.js';

import getOperationData from '../selector/getOperationData.js';

/**
 * Leave live stream
 * @kind action
 * @return {Promise} Action promise.
 */
const leaveLiveStreams = () => async (dispatch, getState) => {
  const currentStreamId = getOperationData(
    getState(),
    ['liveStream'],
    'activeStreamId'
  );
  dispatch(
    setPrivateStreamAutoPayment({ streamId: currentStreamId, isEnabled: false })
  );
  return dispatch(
    setActiveStreamId({
      activeStreamId: undefined,
    })
  );
};

export default leaveLiveStreams;
